module.exports = __webpack_public_path__ + "static/media/close-white.366b05b6.svg";